// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuButton_wrapper__7MZ1p","link":"MenuButton_link__rBlYR"};